import { Type } from "@sinclair/typebox";

import {
  BlockCheckSchema,
  BlockEventHistorySchema,
  BlockType,
} from "../schema.js";

export const NumberSchema = Type.Object({
  prefix: Type.String({ maxLength: 6 }),
  number: Type.String({ maxLength: 8 }),
  private: Type.Boolean(),
  blockType: Type.Enum(BlockType),
  created: Type.String({ format: "date-time" }),
  updatedAt: Type.String({ format: "date-time" }),
});

export const NumberRequestParamSchema = Type.Object({
  number: Type.String({ maxLength: 16 }),
});

export const NumberCheckResponseSchema = Type.Object({
  number: Type.Optional(NumberSchema),
  numbers: Type.Optional(BlockCheckSchema),
  history: Type.Array(BlockEventHistorySchema),
});

export const GetPrefixRequestBodySchema = Type.Object({
  number: Type.String({ maxLength: 16 }),
});

export const GetPrefixSuccessResponseSchema = Type.Object({
  prefix: Type.String({ maxLength: 6 }),
});

export const FreeNumberSuccessResponseSchema = Type.Object({
  deleted: Type.Number(),
});

export const FileUploadSuccessResponseSchema = Type.Object({
  inserted: Type.Number(),
  updated: Type.Number(),
  errors: Type.Array(Type.String()),
});

export const AddPrefixRequestBodySchema = Type.Object({
  prefix: Type.String({ maxLength: 6 }),
});

export const BinaryResponseSchema = Type.String({ format: "binary" });

export const StatisticsSuccessResponseSchema = Type.Object({
  overall: Type.Number({ minimum: 0 }),
  addedLastWeek: Type.Number({ minimum: 0 }),
  privateNumbers: Type.Number({ minimum: 0 }),
  commercialNumbers: Type.Number({ minimum: 0 }),
  commercialNumbersBlockedForAllSurveys: Type.Number({ minimum: 0 }),
});
